import React from 'react'
import classes from './Modal.module.scss'
import Close from '@mui/icons-material/Close';
import { ItineraryFlight, itinerary } from '../../../atom/Types';
import moment from 'moment';
import { FlightSvg } from '../../../constants/resources';
import { selectArray } from '../../NewProposalDesign/VeryNewProposlDesign';
import { Time, handleConnectionDuration, handleDuration } from '../../../atom/utilities/function';

interface props {
    setFlightInfoModal: React.Dispatch<React.SetStateAction<boolean>>
    buliddata: itinerary
    activeFlight: ItineraryFlight[]
    setbuilddata: React.Dispatch<React.SetStateAction<itinerary | undefined>>;
    selectArray: selectArray[];
    setSelectedArray: React.Dispatch<React.SetStateAction<selectArray[]>>;
}

const FlightModal: React.FC<props> = ({ setFlightInfoModal, buliddata, activeFlight, selectArray, setSelectedArray, setbuilddata }) => {


    const handlesingleFlightChoose = (node: ItineraryFlight[]) => {


        const updateData = { ...buliddata }
        const array = [...selectArray];
        if (buliddata.type === 'Proposal') {

            updateData?.proposalView && updateData?.proposalView[node[0].ind ?? -1]?.value?.filter((node) => (node.type === "flight")).forEach((flightss) => {

                if (flightss.id === node[0].id) {
                    flightss.selected = !flightss.selected
                } else flightss.selected = false



                if (flightss.selected) {
                    array.push({ location: updateData?.proposalView && updateData?.proposalView[node[0].ind ? node[0].ind : -1]?.location, data: node[0] })
                    setSelectedArray([...array]);
                } else if (flightss.selected === false) {
                    const index = array.findIndex((n) => n.data.id === flightss.id)
                    if (index > -1) {
                        array.splice(index, 1)
                        setSelectedArray([...array]);
                    }
                }
            })
        }
        else {
            updateData?.days && updateData?.days[node[0].day ? node[0].day - 1 : -1]?.sorted?.filter((node) => (node.type === "flight")).forEach((flightss) => {


                if (flightss.id === node[0].id) {
                    flightss.selected = !flightss.selected
                } else flightss.selected = false



                if (flightss.selected) {
                    array.push({ location: node[0].day?.toString(), data: node[0] })
                    setSelectedArray([...array]);
                } else if (flightss.selected === false) {
                    const index = array.findIndex((n) => n.data.id === flightss.id)
                    if (index > -1) {
                        array.splice(index, 1)
                        setSelectedArray([...array]);
                    }
                }
            })
        }
        setbuilddata({ ...updateData })


        setFlightInfoModal(false);
    }



    return (
        <div className={classes.ModalBackground}>
            <div className={classes.scrollModalContent}>
                <div className={classes.Flex}>
                    <div className={classes.modalTop}>
                        <div className={classes.header}>Your Flight</div>
                        <div className={classes.flightTop}>
                            <button className={classes.CloseButton} onClick={() => setFlightInfoModal(false)}>
                                <Close className={classes.closesvg} />
                            </button>
                        </div>
                    </div>
                    <hr />

                    <div className={classes.ScrollContainer}>
                        {
                            activeFlight.map((node) => {
                                return <div className={classes.container}>
                                    <div>
                                        <div className={classes.subHeader}>
                                            <div>
                                                {
                                                    `${node.flight.departureAirport} (${node.flight?.departure?.airportCode}) - ${node?.connectionFlights.length > 0 ? node?.connectionFlights[node?.connectionFlights.length - 1]?.flight?.arrivalAirport : node.flight.arrivalAirport} (${node?.connectionFlights.length > 0 ? node?.connectionFlights[node?.connectionFlights.length - 1].flight?.arrival?.airportCode : node.flight.arrival?.airportCode})`
                                                }
                                            </div>
                                            <div className={classes.DepartureTime} style={{ color: '#FF3566', margin: '0px 0px 0px 48px' }}>{node?.connectionFlights.length > 0 ? `${node?.connectionFlights.length} stop` : 'Direct Flight'}</div>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            <div className={classes.FlightFeature}>
                                                <div className={classes.DepartureTime}>{moment.utc(node?.departDate).format('dddd, MMMM D YYYY')}
                                                </div>
                                            </div>
                                            <div className={classes.FlightFeature}>
                                                <div className={classes.ArrivalTime}>
                                                    {Time(node?.departTime)} -&nbsp;
                                                    {node?.connectionFlights.length > 0 ? Time(node?.connectionFlights[node?.connectionFlights.length - 1].arrivalTime) : Time(node?.arrivalTime)}
                                                </div>
                                                <div className={classes.DepartureTime}>{handleDuration(node, 'n')}</div>
                                            </div>
                                            <div className={classes.FlightFeature} style={{ paddingTop: '20px' }}>
                                                <div className={classes.DepartureTime} style={{ color: '#273443' }}><span>
                                                    <FlightSvg width='15' height='15' /></span>
                                                    {
                                                        `${node.flight.departureAirport} (${node.flight?.departure?.airportCode}) - ${node.flight.arrivalAirport} (${node?.flight?.arrival?.airportCode})`
                                                    }
                                                </div>
                                                <div className={classes.DepartureTime}>
                                                    {node?.flightCabinType}
                                                </div>
                                            </div>
                                            <div className={classes.FlightFeature}>
                                                <div className={classes.ArrivalTime}>
                                                    {Time(node?.departTime)} -&nbsp;
                                                    {Time(node?.arrivalTime)}
                                                </div>
                                                <div className={classes.DepartureTime}>{handleDuration(node, 'direct')}</div>
                                            </div>
                                            <div className={classes.FlightFeature}>
                                                <div className={classes.ArrivalTime}>
                                                    {node?.flight?.flgithNumber}
                                                </div>
                                                <div className={classes.DepartureTime}>{node?.flight?.airlineName}</div>
                                            </div>
                                            {node?.connectionFlights.length > 0 ?
                                                node.connectionFlights.sort((a, b) => {
                                                    if (a.connectionFlightOrder === null || b.connectionFlightOrder === null)
                                                        return -1
                                                    else
                                                        return a.connectionFlightOrder - b.connectionFlightOrder
                                                })
                                                    .map((n, index: number) => {
                                                        return <div>
                                                            {index === 0 ?
                                                                <div className={classes.DepartureTime} style={{ color: '#FF3566' }}>
                                                                    {handleConnectionDuration(node, n, 'connect')}
                                                                </div> : <div className={classes.DepartureTime} style={{ color: '#FF3566' }}>
                                                                    {handleConnectionDuration(node.connectionFlights[index - 1], node.connectionFlights[index], 'connect')}
                                                                </div>
                                                            }
                                                            <div className={classes.FlightFeature} style={{ paddingTop: '20px' }}>
                                                                <div className={classes.DepartureTime} style={{ color: '#273443' }}><span>
                                                                    <FlightSvg width="15" height="15" /></span>
                                                                    {
                                                                        `${n.flight.departureAirport} (${n.flight?.departure?.airportCode}) - ${n.flight.arrivalAirport} (${n.flight?.arrival?.airportCode})`
                                                                    }
                                                                </div>
                                                                <div className={classes.DepartureTime}>
                                                                    {n?.flightCabinType}
                                                                </div>
                                                            </div>
                                                            <div className={classes.FlightFeature}>
                                                                <div className={classes.ArrivalTime}>
                                                                    {Time(n?.departTime)} -&nbsp;
                                                                    {Time(n?.arrivalTime)}
                                                                </div>
                                                                <div className={classes.DepartureTime}>{handleDuration(n, 'direct')}</div>
                                                            </div>
                                                            <div className={classes.FlightFeature}>
                                                                <div className={classes.ArrivalTime}>
                                                                    {n?.flight?.flgithNumber}
                                                                </div>
                                                                <div className={classes.DepartureTime}>{n?.flight?.airlineName}</div>
                                                            </div>
                                                        </div>
                                                    })
                                                : null}
                                        </div>
                                    </div>

                                </div>
                            })}
                    </div>
                </div>
            </div>

        </div>
    )
}

export default FlightModal